// extracted by css-extract-rspack-plugin
export default {"cls1":"WinBackPing-cls1_YTg","cls2":"WinBackPing-cls2_oj9 WinBackPing-cls1_YTg"};